export const QUERY_PARAM = 'category'
